import { environment } from "src/environments/environment";

export const URL_API:string = environment.url_api;
export const URL_API_V2:string = environment.url_api_v2;
export const URL_API_BR:string = environment.url_api_br;
export const TOKEN_NAME:string = 'idTokenSiteFutureData';
export const SITE_KEY_GCAPTCHA:string = '6Lea9pgUAAAAAMqNkd70HomWC57FZPZSj5CZcq36';
